import "./NotAccess.scss"
import {useNavigate} from "react-router-dom";
import {RouteHelper} from "../../route/RouteHelper";
import notFoundImage from "./403_Error.svg";
import {RaikoButtonPrimary} from "@moeindal/base-raiko-panel-components";

export default function NotAccess() {

    const navigate = useNavigate()

    function handleGoDashboard() {
        navigate(RouteHelper.Dashboard.globalUrl)
    }


    return (
        <div className={"baseNotFoundPageStyle"}>
            <div className={"notFoundItemsContainer"}>
                <img src={notFoundImage} alt=""/>
                <span className={"notFoundTitle"}>عدم دسترسی</span>
                <span
                    className={"notFoundSubtitle"}>آی پی شما متعلق به ایران نمی باشد. در صورت استفاده از vpn آن را خاموش نمایید!</span>
                <RaikoButtonPrimary label={"صفحـه اصلی"} onClick={handleGoDashboard}/>
            </div>
        </div>
    )
}
